import { Routes } from "@angular/router";
import { AppLayout } from "./layouts/app-layout";
import { AuthLayout } from "./layouts/auth-layout";
import { authGuard, guestGuard } from "./guards/auth.guard";

export const routes: Routes = [
  {
    path: 'digilocker-complete',
    loadComponent: () =>
      import('./pages/digilocker-complete/digilocker-complete.component').then(
        (m) => m.DigilockerCompleteComponent,
      ),
  },
  {
    path: "",
    component: AppLayout,
    canActivate: [authGuard],
    children: [
      {
        path: "",
        loadChildren: () =>
          import("./pages/pages.route").then((m) => m.PageRouting),
      },
    ],
  },
  // {
  //   path: "auth",
  //   component: AuthLayout,
  //   canActivate: [guestGuard],
  //   loadChildren: () =>
  //     import("./auth/auth.module").then((m) => m.AuthModule),
  // },
  // { path: "**", redirectTo: "auth/login" },
];
